/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalDocument } from './PortalDocument';
import {
    PortalDocumentFromJSON,
    PortalDocumentFromJSONTyped,
    PortalDocumentToJSON,
    PortalDocumentToJSONTyped,
} from './PortalDocument';

/**
 * 
 * @export
 * @interface PortalDocumentResponse
 */
export interface PortalDocumentResponse {
    /**
     * 
     */
    data: PortalDocument;
}

/**
 * Check if a given object implements the PortalDocumentResponse interface.
 */
export function instanceOfPortalDocumentResponse(value: object): value is PortalDocumentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalDocumentResponseFromJSON(json: any): PortalDocumentResponse {
    return PortalDocumentResponseFromJSONTyped(json, false);
}

export function PortalDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalDocumentFromJSON(json['data']),
    };
}

export function PortalDocumentResponseToJSON(json: any): PortalDocumentResponse {
    return PortalDocumentResponseToJSONTyped(json, false);
}

export function PortalDocumentResponseToJSONTyped(value?: PortalDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalDocumentToJSON(value['data']),
    };
}

